import React from 'react';

/**
 * Kivo token "coin" glyph — a small concentric-ring mark used anywhere we
 * surface credits (header badge, wallet, top-up sheet). Mirrors the coin from
 * the Kivo static-pages design system.
 */
export default function Coin({ size = 16, color }: { size?: number; color?: string }): React.JSX.Element {
  const c = color ?? 'currentColor';
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <circle cx="12" cy="12" r="9.2" stroke={c} strokeWidth="1.7" />
      <circle cx="12" cy="12" r="5" stroke={c} strokeWidth="1.7" />
      <path
        d="M12 2.8v3M12 18.2v3M2.8 12h3M18.2 12h3"
        stroke={c}
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  );
}
